import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Utils from "../../shared/utils";

const CountryGuildLineSplash = (props:any) => {

    const { t } = useTranslation('CountryGuildLineSplash');
    const [state, setState] = useState({
        visible: props,
    });

    useEffect(() => {
    });
    /**
     * Close splash screen
     */
    const close = () => {
        Utils.setStateValue('visible', false, state, setState)
    }

    return (
        state.visible ? 
            <div className="CountryGuildLineSplash">
                <div className="row shadow-lg p-3 mb-5 bg-white big-border-radius splashContent" >
                <div className="closeDiv"><span className="actionIcon closeSpan" onClick={close} >&#x2715;</span></div>
                    <div className='contentDiv'>
                        <object data={`https://rbtest.panapps.co/wp-content/uploads/2022/02/Barometer_Guide-Doc_16_P22-23.pdf`} type="application/pdf" width="100%" height="600px"></object>
                    </div>
                    </div>
            </div>
            :<div></div>
    )
};

export default CountryGuildLineSplash